import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import TableHead from '@/views/CollectionV2/TableHead/index.vue'
import TableBody from '@/views/CollectionV2/TableBody/index.vue'
import Anchor from '@/components/Anchor/index.vue'

import fetch from '@/helpers/fetch'
import tableHelper from '@/helpers/table'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'

import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
	faSort,
	faEye,
	faEyeSlash,
	faArrowDown19,
	faArrowUp,
	faArrowDown,
} from '@fortawesome/free-solid-svg-icons'

Vue.component('v-select', vSelect)

library.add(
	faFilter,
	faCaretUp,
	faChevronRight,
	faChevronLeft,
	faFileExcel,
	faCircleInfo,
	faFileCsv,
	faSort,
	faEye,
	faEyeSlash,
	faArrowDown19,
	faArrowUp,
	faArrowDown,
)

@Component({
	components: {
		Loader,
		TableHead,
		TableBody,
		MessageSuccess,
		Anchor,
	},
})
export default class Collection extends Vue {
	items: any[] = []
	options: object | null | any = null

	viewPage = 1
	totalPages = 0
	totalCount = 0
	countPerPage = 30

	async mounted() {
		this.setLoading(true)

		let columnControl = this.getLocalStorageItem()

		if (!Object.keys(columnControl).length) {
			const defaultFields = {}
			this.fields.forEach((field) => {
				defaultFields[field.fieldName] = {
					visible: field.visible,
					order: field.order,
				}
			})

			this.setLocalStorageItem(defaultFields)

			columnControl = this.getLocalStorageItem()
		}

		await this.fetchData()

		this.filterFields({})

		this.setLoading(false)
	}

	filterFields(fieldName?, value?) {
		let columnControl = this.getLocalStorageItem() || {}

		if (fieldName && value !== undefined) {
			if (columnControl[fieldName]) {
				columnControl[fieldName].visible = value
			} else {
				// Se o campo não existe, inicializar com ordem do campo original
				const originalField = this.allFields.find(
					(f) => f.fieldName === fieldName,
				)
				columnControl[fieldName] = {
					visible: value,
					order: originalField?.order,
				}
			}
		}

		this.setLocalStorageItem(columnControl)

		this.allFields.forEach((field) => {
			if (columnControl[field.fieldName]) {
				field.visible = columnControl[field.fieldName].visible
				field.order = columnControl[field.fieldName].order
			}
		})

		this.allFields.sort((a, b) => a.order - b.order)

		this.fields = this.allFields
			.filter(
				(field) => columnControl[field.fieldName]?.visible !== false,
			)
			.sort((a, b) => a.order - b.order)
	}

	getLocalStorageItem() {
		return JSON.parse(localStorage.getItem('columnControl') || '{}')
	}

	setLocalStorageItem(value) {
		localStorage.setItem('columnControl', JSON.stringify(value))
	}

	async fetchData() {
		const result = await Promise.all([
			this.onFilter({}),
			fetch.get(
				'/api/collections/options?options=group_name,client_name,cnj,lawsuit_types,systems,court_houses,subjects,elaborator,reviewer,advocate,city,state ',
			),
		])
		const [resData, resOptions] = result

		if (resOptions.ok && resOptions.data.options) {
			this.options = resOptions.data.options

			if (this.options) {
				this.allFields.forEach((field) => {
					if (field.options && !field.options.length) {
						let options = [] as any[]

						if (field.optionsLabel) {
							options = (this.options as object)[
								field.optionsLabel
							]
						}

						options = options.map((option, index) => {
							return {
								index: index + 1,
								...option,
								exists: true,
							}
						})

						Vue.set(field, 'options', options)
					}
				})
			}
		}

		if (resData.ok && resData.data) {
			this.items = resData.data

			this.setCountAndPages(resData?.acervo_aggregate?.aggregate?.count)
		}
	}

	setCountAndPages(totalCount) {
		if (totalCount || totalCount === 0) {
			this.totalCount = totalCount
			this.totalPages = Math.ceil(this.totalCount / this.countPerPage)
		}
	}

	setLoading(loading) {
		this.fields.forEach((field) => {
			Vue.set(field, 'loading', loading)
		})

		if (loading) {
			this.items = getLoadingItems()
		}
	}

	filters: null | object = null
	async onFilter(filter) {
		if (Object.keys(filter).length > 0) {
			this.viewPage = 1
		}

		this.filters = {
			...this.filters,
			...filter,
		}

		const params = createUrlFilterParams(this.filters)

		const url =
			`/api/collections/search?items=${this.countPerPage}&page=${this.viewPage}&` +
			params.join('&')

		const res = await fetch.get(url)
		if (res.ok && res?.data) {
			this.setLoading(false)
			this.items = res?.data

			this.setCountAndPages(res?.acervo_aggregate?.aggregate?.count)
		}

		return res
	}

	fields: any[] = getFields()
	allFields: any[] = getFields()

	moveUp(fieldName) {
		const sortedFields = [...this.allFields].sort(
			(a, b) => a.order - b.order,
		)

		const currentIndex = sortedFields.findIndex(
			(field) => field.fieldName === fieldName,
		)

		if (currentIndex <= 0) return // Já está no topo

		const selectedField = sortedFields[currentIndex]
		const prevField = sortedFields[currentIndex - 1]

		;[selectedField.order, prevField.order] = [
			prevField.order,
			selectedField.order,
		]

		const columnControl = this.getLocalStorageItem()
		columnControl[selectedField.fieldName].order = selectedField.order
		columnControl[prevField.fieldName].order = prevField.order
		this.setLocalStorageItem(columnControl)

		this.filterFields()
	}

	moveDown(fieldName) {
		const sortedFields = [...this.allFields].sort(
			(a, b) => a.order - b.order,
		)

		const currentIndex = sortedFields.findIndex(
			(field) => field.fieldName === fieldName,
		)

		if (currentIndex === -1 || currentIndex >= sortedFields.length - 1) {
			return
		}

		const selectedField = sortedFields[currentIndex]
		const nextField = sortedFields[currentIndex + 1]

		;[selectedField.order, nextField.order] = [
			nextField.order,
			selectedField.order,
		]

		const columnControl = this.getLocalStorageItem()
		columnControl[selectedField.fieldName].order = selectedField.order
		columnControl[nextField.fieldName].order = nextField.order
		this.setLocalStorageItem(columnControl)

		this.filterFields()
	}

	async previous() {
		if (this.viewPage > 1) {
			this.setLoading(true)
			this.viewPage--
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	async next() {
		if (this.viewPage < this.totalPages) {
			this.setLoading(true)
			this.viewPage++
			await this.onFilter({})
			this.setLoading(false)
		}
	}

	downloading = false
	csvHref = ''
	downloadProp = ''
	async downloadCsv() {
		this.downloading = true

		const params = createUrlFilterParams(this.filters)

		const url = `/api/collections/download-csv?` + params.join('&')

		window.open(url, '_blank')
		//const res = await fetch.get(url)

		this.downloading = false
		/*
		const res = await this.onFilter({})

		const csvContent = res.csv
		const encodedUri = encodeURI(csvContent)

		this.csvHref = 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri

		const time = new Date().getTime() - 3 * 60 * 60 * 1000

		this.downloadProp =
			'acervo-' + new Date(time).toISOString().substring(0, 16) + '.csv'

		await Vue.nextTick()
		const link: any = this.$refs.csvLink

		if (link && link.click) {
			link.click()
			this.downloading = false
		}
		*/
	}
}

function formatDate(date) {
	return date?.split('-')?.reverse()?.join('/')
}

function createUrlFilterParams(filter) {
	const params: any = []
	if (filter && typeof filter === 'object') {
		const keys = Object.keys(filter)

		keys.forEach((key) => {
			const value = filter[key]

			if (typeof value !== 'object') {
				if (value || value === false || value === 0) {
					params.push(`${key}=${encodeURIComponent(value)}`)
				}
			} else {
				if (value?.from) {
					params.push(`${key}_from=${encodeURIComponent(value.from)}`)
				}

				if (value?.to) {
					params.push(`${key}_to=${encodeURIComponent(value.to)}`)
				}
			}
		})
	}

	return params
}

function getFields() {
	return [
		{
			humanName: '#',
			fieldName: 'index',
			'min-width': '49px',
			fixedColumn: true,
			loading: true,
		},
		{
			order: 1,
			humanName: 'Cliente',
			fieldName: 'group',
			type: 'v-select',
			optionsLabel: 'group_name',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'group',
				model: '',
			},
			'max-width': '250px',
			'min-width': '250px',
			fixedColumn: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			format(client) {
				return client?.[0]?.group?.name || '-'
			},
			unformat(client) {
				return client ? client?.id : null
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 2,
			humanName: 'Empresa',
			fieldName: 'clients',
			type: 'v-select',
			optionsLabel: 'client_name',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'client',
				model: '',
			},
			'max-width': '350px',
			'min-width': '350px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			format(company) {
				if (!company?.length) return '-'

				return (
					company
						.map((item) => item?.client?.name || '-')
						.join(', ') || '-'
				)
			},
			unformat(company) {
				return company ? company.id : null
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 3,
			humanName: 'Processo',
			fieldName: 'cnj',
			type: 'v-select',
			optionsLabel: 'cnj',
			options: [],
			vSelectLabel: 'cnj',
			create: {
				model: '',
			},
			'v-mask': '#######-##.####.#.##.####',
			filter: {
				name: 'cnj',
				model: '',
			},
			'max-width': '250px',
			'min-width': '250px',
			format(cnj) {
				if (cnj && typeof cnj !== 'string') return ''
				return tableHelper.formatCNJ(cnj)
			},
			unformat(cnj) {
				if (cnj?.cnj) {
					return cnj?.cnj.replace(/\./g, '')?.replace('-', '')
				}
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		{
			order: 4,
			humanName: 'Tipo',
			fieldName: 'lawsuitType',
			type: 'v-select',
			optionsLabel: 'lawsuit_types',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'lawsuitType',
				model: '',
			},
			'max-width': '350px',
			'min-width': '350px',
			unformat(lawsuitType) {
				if (lawsuitType?.id) {
					return lawsuitType?.id
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 5,
			humanName: 'Trâmite',
			fieldName: 'procedure',
			type: 'v-select',
			optionsLabel: '',
			options: [{ name: 'Eletrônico' }, { name: 'Físico' }],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'procedure',
				model: '',
			},
			'max-width': '190px',
			'min-width': '190px',
			unformat(procedure) {
				if (procedure?.name) {
					return procedure?.name
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 6,
			humanName: 'Sistema',
			fieldName: 'system',
			type: 'v-select',
			optionsLabel: 'systems',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'system',
				model: '',
			},
			'max-width': '210px',
			'min-width': '210px',
			unformat(system) {
				if (system?.id) {
					return system?.id
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 7,
			humanName: 'Tribunal',
			fieldName: 'originCourt',
			type: 'v-select',
			optionsLabel: 'court_houses',
			options: [],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'originCourt',
				model: '',
			},
			'max-width': '130px',
			'min-width': '130px',
			unformat(originCourt) {
				if (originCourt?.name) {
					return originCourt?.name
				}
			},
			loadingPlaceholder: 'AAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 8,
			humanName: 'Assunto',
			fieldName: 'subjects',
			width: '450px',
			type: 'v-select',
			optionsLabel: 'subjects',
			options: [],
			vSelectLabel: 'name',
			filter: {
				name: 'subject',
				model: '',
			},
			format(subjects) {
				if (!subjects?.length) return '-'

				const filtered = subjects
					.map((item, index) => ({
						name: item?.subject?.name || '-',
						index: index + 1,
					}))
					.filter((item) => item.name !== '[EM BRANCO]')

				return filtered.length
					? filtered
							.map((item) => `${item.name} (${item.index})`)
							.join(', ')
					: '-'
			},
			unformat(subject) {
				if (subject?.id) {
					return subject?.id
				}
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		// {
		// 	order: 9,
		// 	humanName: 'Probabilidade de perda',
		// 	fieldName: 'loosingChance',
		// 	width: '250px',
		// 	type: '',
		// 	optionsLabel: '',
		// 	options: [],
		// 	vSelectLabel: '',
		// 	filter: {
		// 		name: 'loosingChance',
		// 		model: '',
		// 	},
		// 	format(loosingChance) {
		// 		if (!loosingChance?.length) return '-'

		// 		const filtered = loosingChance
		// 			.map((item, index) => ({
		// 				loosingChance: item?.loosingChance || '-',
		// 				subject: item?.subject?.name || '-',
		// 				index: index + 1,
		// 			}))
		// 			.filter((item) => item.subject !== '[EM BRANCO]')

		// 		return filtered.length
		// 			? filtered
		// 					.map(
		// 						(item) =>
		// 							`${item.loosingChance || ''} (${item.index})`,
		// 					)
		// 					.join(', ')
		// 			: '-'
		// 	},
		// 	loading: true,
		// 	loadingPlaceholder: 'AAAAAAAAAAAAAA',
		// 	visible: true,
		// },
		{
			order: 9,
			humanName: 'Status',
			fieldName: 'status',
			type: 'v-select',
			optionsLabel: '',
			options: [
				{
					name: 'Arquivado',
				},
				{
					name: 'Ativo',
				},
				{
					name: 'Desistência',
				},
				{
					name: 'Habilitação de crédito',
				},
				{
					name: 'Sobrestado',
				},
				{
					name: 'Substabelecido',
				},
				{
					name: 'Trânsito em julgado desfavorável',
				},
				{
					name: 'Trânsito em julgado favorável',
				},
				{
					name: 'Trânsito em julgado favorável parcial',
				},
			],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: '',
				model: '',
			},
			unformat(status) {
				if (status?.name) {
					return status?.name
				}
			},
			'max-width': '280px',
			'min-width': '280px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 10,
			humanName: 'Posição',
			fieldName: 'clientPosition',
			type: 'v-select',
			optionsLabel: '',
			options: [
				{
					name: 'Ativo',
				},
				{
					name: 'Ativo - desdobramento',
				},
				{
					name: 'Passivo',
				},
				{
					name: 'Passivo - desdobramento',
				},
			],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: '',
				model: '',
			},
			unformat(clientPosition) {
				if (clientPosition?.name) {
					return clientPosition?.name
				}
			},
			'max-width': '200px',
			'min-width': '200px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 11,
			humanName: 'Encerrado',
			fieldName: 'closed',
			type: 'v-select',
			optionsLabel: '',
			options: [
				{
					name: 'Sim',
				},
				{
					name: 'Não',
				},
				{
					name: 'Ambos',
				},
			],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'closed',
				model: '',
			},
			'max-width': '200px',
			'min-width': '200px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			format(closed) {
				if (closed === true) return 'Sim'
				if (closed === false) return 'Não'
				return '-'
			},
			unformat(closed) {
				if (closed?.name === 'Sim') {
					closed.name = true
				}
				if (closed?.name === 'Não') {
					closed.name = false
				}
				return closed.name
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 12,
			humanName: 'Data de distribuição',
			fieldName: 'distributionDate',
			'min-width': '200px',
			type: 'date',
			filter: {
				name: 'distributionDate',
				model: '',
			},
			format(value) {
				return formatDate(value)
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		{
			order: 13,
			humanName: 'Data inicial locatelli',
			fieldName: 'locatelliStartDate',
			'min-width': '200px',
			type: 'date',
			filter: {
				name: 'locatelliStartDate',
				model: '',
			},
			format(value) {
				return formatDate(value)
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		{
			order: 14,
			humanName: 'Data de arquivamento definitivo',
			fieldName: 'distributionEndDate',
			'min-width': '300px',
			type: 'date',
			filter: {
				name: 'distributionEndDate',
				model: '',
			},
			format(value) {
				return formatDate(value)
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		{
			order: 15,
			humanName: 'Data de arquivamento locatelli',
			fieldName: 'locatelliEndDate',
			'min-width': '300px',
			type: 'date',
			filter: {
				name: 'locatelliEndDate',
				model: '',
			},
			format(value) {
				return formatDate(value)
			},
			loading: true,
			loadingPlaceholder: 'AAAAAAAAAAAAAA',
			visible: true,
		},
		{
			order: 16,
			humanName: 'Elaborador',
			fieldName: 'elaborator',
			type: 'v-select',
			optionsLabel: 'elaborator',
			options: [],
			vSelectLabel: 'email',
			create: {
				model: '',
			},
			filter: {
				name: 'elaborator',
				model: '',
			},
			'max-width': '280px',
			'min-width': '280px',
			loadingPlaceholder: 'AAAAAAAAAAAAA',
			loading: true,
			unformat(elaborator) {
				if (elaborator) {
					return elaborator.email
				}
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 17,
			humanName: 'Revisor',
			fieldName: 'reviewer',
			type: 'v-select',
			optionsLabel: 'reviewer',
			options: [],
			vSelectLabel: 'email',
			create: {
				model: '',
			},
			filter: {
				name: 'reviewer',
				model: '',
			},
			'max-width': '280px',
			'min-width': '280px',
			loadingPlaceholder: 'AAAAAAAAAAAAA',
			loading: true,
			unformat(reviewer) {
				if (reviewer) {
					return reviewer.email
				}
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 18,
			humanName: 'Advogado',
			fieldName: 'advocate',
			type: 'v-select',
			optionsLabel: 'advocate',
			options: [],
			vSelectLabel: 'email',
			create: {
				model: '',
			},
			filter: {
				name: 'advocate',
				model: '',
			},
			'max-width': '280px',
			'min-width': '280px',
			loadingPlaceholder: 'AAAAAAAAAAAAA',
			loading: true,
			unformat(advocate) {
				if (advocate) {
					return advocate.email
				}
			},
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 19,
			humanName: 'Cidade',
			fieldName: 'city',
			type: 'v-select',
			optionsLabel: 'city',
			options: [],
			vSelectLabel: 'city',
			create: {
				model: '',
			},
			filter: {
				name: 'city',
				model: '',
			},
			unformat(city) {
				if (city?.city) {
					return city?.city
				}
			},
			'max-width': '200px',
			'min-width': '200px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 20,
			humanName: 'Estado',
			fieldName: 'state',
			type: 'v-select',
			optionsLabel: 'state',
			options: [],
			vSelectLabel: 'state',
			create: {
				model: '',
			},
			filter: {
				name: 'state',
				model: '',
			},
			unformat(state) {
				if (state?.state) {
					return state?.state
				}
			},
			'max-width': '200px',
			'min-width': '200px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAA',
			loading: true,
			onDatabase: true,
			createOrder: 2,
			taggable: true,
			visible: true,
		},
		{
			order: 21,
			humanName: 'Prioridade de Envio',
			fieldName: 'shipping_priority',
			type: 'v-select',
			optionsLabel: '',
			options: [{ name: 'Sim' }, { name: 'Não' }],
			vSelectLabel: 'name',
			create: {
				model: '',
			},
			filter: {
				name: 'shipping_priority',
				model: '',
			},
			'max-width': '220px',
			'min-width': '220px',
			loadingPlaceholder: 'AAAAAAAAAAAAAAAAAAAA',
			loading: true,
			format(value) {
				if (value === true) return 'Sim'
				if (value === false) return 'Não'
				return '-'
			},
			unformat(value) {
				if (value?.name === 'Sim') return true
				if (value?.name === 'Não') return false
				return null
			},
			onDatabase: true,
			createOrder: 2,
			visible: true,
		},
	].sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0))
}

function getLoadingItems() {
	return [
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
		{
			loading: true,
		},
	]
}
